import React, { useState, useEffect, Fragment, useRef } from "react";
import setFile from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import Form1 from "./form_1";
import Form2 from "./form_2";
import Form3 from "./form_3";
import Form4 from "./form_4";
import Form5 from "./form_5";
import Form6 from "./form_6";
import Form7 from "./form_7";
import Form8 from "./form_8";
import Form9 from "./form_9";
import Form10 from "./form_10";
import RequestStatus from "./request_status";
import RequestApprove from "./request_approve";
import logoHead from "./logo/cder_logo.png";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";

export const Request_submit = ({ setAuth }) => {
  const [name, setName] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);
  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setUserRole(parsRes.emp_role);
      setUserId(parsRes.emp_id);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [selectedForm, setSelectedForm] = useState("");
  const [forms, setForms] = useState([]);

  const fetchForms = async () => {
    // Fetch the forms and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/forms`
    );
    const data = await response.json();

    data.sort((a, b) => {
      const valueA = a.doc_type_id;
      const valueB = b.doc_type_id;
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }

      return 0;
    });

    if (userRole === 25) {
      setForms(data.filter((form) => form.doc_type_id < 6));
      setSelectedForm("empty");
    } else {
      if (isPnrHos(userRole)) {
        setForms(
          data.filter((form) => form.doc_type_id < 7 && form.doc_type_id > 1)
        );
        setSelectedForm("empty");

      } else {
        setForms(
          data.filter((form) => form.doc_type_id < 6 && form.doc_type_id > 1)
        );
        setSelectedForm("empty");

      }
    }
  };
  const [structures, setStructures] = useState([]);
  const getStrs = async () => {
    try {
      const response = await fetch(`/api/structures`,
        {
          method: "GET",
          headers: { token: localStorage.token }
        });
      const data = await response.json();
      setStructures(data);
    } catch (err) {
      console.error(err.message);
    }
  }

  const isPnrHos = (currUserRole) => {
    let count = 0;
    for (let i = 0; i < structures.length; i++) {
      if ((currUserRole === structures[i].str_head) && (structures[i].str_parent === 15 || structures[i].str_parent === 17) || (currUserRole === 30 || currUserRole === 31)) {
        count = count + 1;
      }
    }
    if (count != 0) {
      return true;
    } else return false;
  }

  const handleFormSelect = (e) => {
    e.preventDefault();
    setSelectedForm("form" + e.target.value);
    setMultipleFiles([]);
  };

  useEffect(() => {
    getName();
    getStrs();
  }, []);

  useEffect(() => {
    fetchForms();
  }, [userRole]);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast("Déconnecté");
  };

  // file upload ----------------------------------------------

  const FileItem = ({ name, url, onRemoveClick }) => {
    return (
      // Renders a file item in the file list
      <li style={{ listStyleType: "none" }} className="fileItem-list">
        <div className="fileItem-name-clsbtn-container">
          <span className="fileItem-title">{name}</span>
          <button
            className="fileItem-close-btn"
            href="#"
            onClick={onRemoveClick}
          >
            X
          </button>
        </div>
        {name.endsWith(".jpeg") ||
          name.endsWith(".jpg") ||
          name.endsWith(".png") ||
          name.endsWith(".svg") ? (
          // Image file
          <img
            style={{ maxWidth: "300px", maxHeight: "300px" }}
            src={url}
            alt={name}
          />
        ) : (
          // Other file type
          <iframe className="fileItem-iframe" src={url}></iframe>
        )}
      </li>
    );
  };

  const refInput = useRef();
  const [multipleFiles, setMultipleFiles] = useState([]);

  const handleFileChange = (e) => {
    setMultipleFiles([...multipleFiles, e.target.files[0]]);
    console.log(URL.createObjectURL(e.target.files[0]));
  };

  const handleFileSubmit = () => {
    const formDatas = new FormData();
    formDatas.append("reqId", currentReqId);
    for (let i = 0; i < multipleFiles.length + 1; i++) {
      formDatas.append("file", multipleFiles[i]);
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/upload_files_internal`, {
      method: "POST",
      body: formDatas,
    })
      .then((res) => {
        console.log(res.json());
        if (res.status === 200) {
          setSubmitTriggered(false);
          setMultipleFiles([]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // ----------------------------------------------------------------

  // receive data from the child component (last reqId from the database) ----------
  const [currentReqId, setCurrentReqId] = useState("");

  const sendData = (data) => {
    setCurrentReqId((data + 1).toString());
  };

  const [submitTriggered, setSubmitTriggered] = useState(false);

  const triggerFileUpload = (data) => {
    setSubmitTriggered(data);
  };

  // -------------------------------------------------------------------------------

  useEffect(() => {
    if (submitTriggered === true) {
      handleFileSubmit();
    }
  }, [submitTriggered]);

  const showSideBar = () => {
    const sideBar = document.querySelector(".side-nav");
    sideBar.style.display = "flex";
  };

  const hideSideBar = () => {
    const sideBar = document.querySelector(".side-nav");
    sideBar.style.display = "none";
  };

  return (
    <Fragment>
      <div className="req-submit-display">
        {/* <div className=" m-0  text-white main-banner">
          <div className="head-banner-logo">
            <img src={logoHead} alt="logoHead" />
          </div>
          <div className="banner-text-1">
            <p>
              République Algérienne Démocratique et Populaire Ministère de
              l'Enseignement Supérieur et de la Recherche Scientifique Direction
              Générale de la Recherche Scientifique et du Développement
              Technologique
            </p>
          </div>
          <div className="banner-text-2">
            <span>EPST/Centre de Développement des Energies Renouvelables</span>
          </div>
        </div> */}

        <div className="topnav">
          <div onClick={showSideBar} className="menu-icon-container ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
              className="my-svg"
            >
              <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
            </svg>
          </div>
          <div className="left-menu-4">
            <Link to="/dashboard">Accueil</Link>
          </div>
          <div className="right-menu">
            <button className="dash-logout" onClick={(e) => logout(e)}>
              Se déconnecter
            </button>

            <div className=" relative flex items-center justify-center float-right pr-3">
              <span className="p-3 text-white">{name}</span>
            </div>
          </div>
        </div>

        <div className="side-nav">
          <div onClick={hideSideBar} className="menu-close-icon-container ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
              className="my-svg"
            >
              <path
                fill="#FFFFFF"
                d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
              />
            </svg>
          </div>

          <Link to="/dashboard">home</Link>

          <div className=" relative flex items-center justify-center float-left pr-3">
            <span className="p-3 text-white">{name}</span>
          </div>
          <button className="dash-logout" onClick={(e) => logout(e)}>
            Se déconnecter
          </button>
        </div>

        <div className="dash-body">
          <div className="dash-grid">
            <div className="dash-content-selector">
              <select
                defaultValue={0}
                className="form-control"
                onChange={handleFormSelect}
              >
                <option disabled default value={0}>
                  ----selectionnez----
                </option>
                {forms.map((form) => (
                  <option key={form.doc_type_id} value={form.doc_type_id}>
                    {form.doc_tittle}
                  </option>
                ))}
              </select>
            </div>

            {selectedForm && (
              <div className="dash-content-wrap">
                {selectedForm === "empty" && (
                  <div className=" flex-1  h-[400px]"></div>
                )}
                {selectedForm === "form1" && (
                  <Form1
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form2" && (
                  <Form2
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form3" && (
                  <Form3
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form4" && (
                  <Form4
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form5" && (
                  <Form5
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form6" && (
                  <Form6
                    sendData={sendData}
                    triggerFileUpload={triggerFileUpload}
                  />
                )}
                {selectedForm === "form7" && <Form7 />}
                {selectedForm === "form8" && <Form8 />}
                {selectedForm === "form9" && <Form9 />}
                {selectedForm === "form10" && <Form10 />}

                {/* ... */}
              </div>
            )}
            {/* <div className='grid-side-left'>
          <RequestStatus />
        </div> */}
          </div>
          <div className="navBarControls">
            <div className="file_upload">
              <form
                onSubmit={handleFileSubmit}
                action="/upload_files"
                method="post"
                encType="multipart/form-data"
              >
                <input
                  type="file"
                  ref={refInput}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <div>
                  <span>Joindre des fichiers avec la demande</span>

                  <ul>
                    {multipleFiles.map((f, index) => (
                      <FileItem
                        key={index}
                        name={f.name}
                        url={URL.createObjectURL(f)}
                        onRemoveClick={() => {
                          setMultipleFiles((prevFiles) =>
                            prevFiles.filter((_, idx) => idx !== index)
                          );
                        }}
                      />
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    refInput.current?.click();
                  }}
                >
                  +
                </button>

                {/* <button type="submit">Télécharger</button> */}
              </form>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </Fragment>
  );
};
